import React from 'react';
import { useHistory } from 'react-router-dom';
import { v4 as uuidv4 } from 'uuid';
import sensorsActions from '../../../../../actions/sensors.actions';
import {
  getAssignedSensorsByCurrentUser,
  putMapShapes,
  putMapBackground,
  getMapInfo,
  getMapBg,
} from '../../../../../api';
import lookupApi from '../../../../../api/lookup';
import helper from '../../../../../utils/helper';
import CUMap from '../CUMap';
import { getSensorBgColor, getSquareBgColor } from '../MapEditor/Helpers/func';

const EditMap = (props) => {
  const history = useHistory();
  const { deptId, mapName } = helper.parseQueryString(props.location.search);
  const [sensors, setSensors] = React.useState([]);
  const [groups, setGroups] = React.useState([]);
  const [errors, setErrors] = React.useState('');
  const [loading, setLoading] = React.useState(false);
  const [submitting, setSubmitting] = React.useState(false);
  const [map, setMap] = React.useState(null);
  const [mapBg, setMapBg] = React.useState(null);
  const [shapes, updateShapes] = React.useState([]);

  React.useEffect(() => {
    setLoading(true);
    getAssignedSensorsByCurrentUser()
      .then((resp) => setSensors(resp))
      .catch((err) => setErrors(err));
    lookupApi
      .getGroups()
      .then((resp) => setGroups(resp.items))
      .catch((err) => setErrors(err));
    getMapInfo(deptId, mapName)
      .then((resp) => setMap(resp))
      .catch((err) => setErrors(err));
    getMapBg(deptId, mapName)
      .then((resp) => setMapBg(resp))
      .catch((err) => setErrors(err));
    setLoading(false);
  }, []);
  function onEditMap(values) {
    const mapShapes = {
      name: values.name,
      ...values.shapes,
    };

    setSubmitting(true);
    Promise.all([
      values.bgFile
        ? putMapBackground(deptId, values.name, values.bgFile)
        : Promise.resolve(),
      putMapShapes(deptId, values.name, mapShapes),
    ])
      .then(() => history.goBack())
      .catch((err) => setSubmitting(false));
  }
  function gcd(a, b) {
    return b === 0 ? a : gcd(b, a % b);
  }
  const mapInfo = {
    name: map ? map.name : '',
    description: map ? map.description : '',
  };
  React.useEffect(() => {
    if (map && map.shapes.length) {
      map.shapes.map(async (shape, index) => {
        const shapeCopy = Object.assign({}, shape);
        delete shapeCopy['width'];
        delete shapeCopy['height'];
        delete shapeCopy['x'];
        delete shapeCopy['y'];
        const id = `shape${uuidv4()}`;
        let alarmBackgroundColor = '';
        let alarmValue = '';
        if (
          // shapeCopy.className.match(/Multi|CircleShape/g) &&
          // shapeCopy.valueBackGroundColor === 'alarm' &&
          ((shapeCopy.className === 'Multi' &&
            shapeCopy.valueBackGroundColor === 'alarm') ||
            shapeCopy.className === 'CircleShape') &&
          shapeCopy.sensorId !== undefined &&
          shapeCopy.sensorId !== 0
        ) {
          await sensorsActions
            .getAlarmStatusV2(shapeCopy.sensorId)
            .then((resp) => {
              alarmBackgroundColor = getSensorBgColor(
                resp[0] && resp[0].alarmPriority,
              );
              alarmValue = resp[0] && `${resp[0].textValue} ${resp[0].units}`;
            });
        }

        if (
          shapeCopy.className.match(/SquareShape/g) &&
          shapeCopy.groupId !== undefined
        ) {
          await sensorsActions
            .getAlarmStatusByGroupV2(shapeCopy.groupId)
            .then((resp) => {
              alarmBackgroundColor = getSquareBgColor(resp);
              alarmValue = resp[0] && `${resp[0].textValue} ${resp[0].units}`;
            });
        }
        let _shape = {
          id,
          className: shape.className,
          name: `${shape.className} ${index}`,
          zIndex: index,
          position: { left: shape.x, top: shape.y },
          dimension: { width: shape.width, height: shape.height },
          alarmBackgroundColor,
          alarmValue,
          ...shapeCopy,
        };
        updateShapes((shapes) => [...shapes, _shape]);
      });
    }
    return () => {};
  }, [map]);

  // React.useEffect(() => {
  //   if (shapes.length) {
  //     const sensorIds = Array.from(
  //       new Set(
  //         shapes
  //           .filter((shape) => shape.type.match(/Multi|CircleShape/g))
  //           .map((shape) => shape.sensorId),
  //       ),
  //     );
  //     if (sensorIds.length) {
  //       sensorsActions
  //         .getAlarmStatusV2(sensorIds)
  //         .then((resp) => {

  //         });
  //     }
  //   }
  // }, [shapes]);

  let bg = null;
  let originalDimension = null;
  if (map) {
    bg = {
      className: 'Background',
      image: { src: mapBg },
      position: { left: 0, top: 0 },
      dimension: { width: map.width, height: map.height },
    };
    originalDimension = {
      width: map.width,
      height: map.height,
      ratio: gcd(map.width, map.height),
    };
  }
  return (
    <CUMap
      isEdit
      submitting={submitting}
      mapInfo={mapInfo}
      shapes={shapes}
      bg={bg}
      originalDimension={originalDimension}
      sensors={sensors}
      groups={groups}
      errors={errors}
      map={map}
      onEditMap={onEditMap}
      onBack={() => history.goBack()}
    />
  );
};

export default EditMap;
